import React, { FC } from 'react';
import { DocumentationHeaderLogoElement } from '../../graphql/__generated__/types';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkIllustrations } from 'uitk-react-illustrations';
import { UitkText } from 'uitk-react-text';
import { useHistory } from 'react-router-dom';
import { getHubBasePath } from '../../utils/url';

interface PageHeaderLogoProps {
  logo: DocumentationHeaderLogoElement;
  hubName: string;
}

const HeaderLogo: FC<PageHeaderLogoProps> = ({ logo, hubName }) => {
  const { push, location } = useHistory();

  const navigateToHomePage = () => {
    push(getHubBasePath(location.pathname));
  };

  return (
    <UitkLayoutFlex
      className="logo-section"
      id="logo-section"
      onClick={navigateToHomePage}
      alignItems="center"
      space="two"
    >
      <UitkLayoutFlexItem>
        <UitkIllustrations alt={logo.altText} url={logo.imgSrc.url} className="logo" />
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>
        <UitkText weight="medium" size={400}>
          {hubName}
        </UitkText>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
};

export default HeaderLogo;
